import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Alert } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { 
  Block as BlockIcon, 
  LockClock as LockClockIcon,
  Delete as DeleteIcon,
  Warning as WarningIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';

const FormularioBloqueado = ({ motivo, codigo, formularioInfo, esSoloLectura, esFinalizado }) => {
  const navigate = useNavigate();
  const colorPrincipal = "#10407D";

  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const [anio, mes, dia] = fecha.split('-');
    return `${dia}/${mes}/${anio}`;
  };

  const getIcono = () => {
    if (esFinalizado) {
      return <VisibilityIcon style={{ fontSize: 80, color: colorPrincipal }} />;
    }
    
    switch(codigo) {
      case 'EXPIRADO':
        return <LockClockIcon style={{ fontSize: 80, color: colorPrincipal }} />;
      case 'ELIMINADO':
        return <DeleteIcon style={{ fontSize: 80, color: colorPrincipal }} />;
      case 'GENERAL_INACTIVO':
        return <BlockIcon style={{ fontSize: 80, color: colorPrincipal }} />;
      case 'NO_INICIADO':
        return <LockClockIcon style={{ fontSize: 80, color: colorPrincipal }} />;
      default:
        return <WarningIcon style={{ fontSize: 80, color: colorPrincipal }} />;
    }
  };

  const getTitulo = () => {
    if (esFinalizado) {
      return 'Formulario Finalizado';
    }
    
    switch(codigo) {
      case 'EXPIRADO':
        return 'Formulario Expirado';
      case 'ELIMINADO':
        return 'Formulario Eliminado';
      case 'GENERAL_INACTIVO':
        return 'Formulario Inactivo';
      case 'NO_INICIADO':
        return 'Formulario No Iniciado';
      default:
        return 'Acceso Denegado';
    }
  };

  const getMensaje = () => {
    if (esFinalizado) {
      return 'Este formulario ha sido finalizado. Puedes visualizarlo pero no editarlo.';
    }
    return motivo || 'No tienes acceso a este formulario';
  };

  const getVariant = () => {
    if (esFinalizado) {
      return 'info';
    }
    return 'warning';
  };

  const irAMisFormularios = () => {
    navigate('/proveedor/form');
  };

  if (esSoloLectura || esFinalizado) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
        <Card style={{ maxWidth: 500, width: '100%', textAlign: 'center', padding: '2rem' }}>
          <div className="mb-4">
            <VisibilityIcon style={{ fontSize: 80, color: colorPrincipal }} />
          </div>
          
          <h2 style={{ color: colorPrincipal, marginBottom: '1rem' }}>
            Formulario Finalizado
          </h2>
          
          <Alert 
            variant="info"
            style={{ marginBottom: '1.5rem' }}
          >
            Este formulario ha sido finalizado. Puedes visualizarlo pero no editarlo.
          </Alert>
          
          {formularioInfo && (
            <div style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '1rem', 
              borderRadius: '8px',
              marginBottom: '1.5rem',
              textAlign: 'left',
              color: colorPrincipal
            }}>
              {formularioInfo.titulo && (
                <p><strong>Título:</strong> {formularioInfo.titulo}</p>
              )}
              {formularioInfo.fecha_fin && (
                <p><strong>Fecha de finalización:</strong> {formatearFecha(formularioInfo.fecha_fin)}</p>
              )}
            </div>
          )}
          
          <Button 
            onClick={irAMisFormularios}
            style={{ 
              backgroundColor: colorPrincipal, 
              borderColor: colorPrincipal 
            }}
            size="lg"
          >
            Volver a Mis Formularios
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
      <Card style={{ maxWidth: 500, width: '100%', textAlign: 'center', padding: '2rem' }}>
        <div className="mb-4">
          {getIcono()}
        </div>
        
        <h2 style={{ color: colorPrincipal, marginBottom: '1rem' }}>
          {getTitulo()}
        </h2>
        
        <Alert 
          variant={getVariant()}
          style={{ marginBottom: '1.5rem' }}
        >
          {getMensaje()}
        </Alert>
        
        {formularioInfo && (
          <div style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '1rem', 
            borderRadius: '8px',
            marginBottom: '1.5rem',
            textAlign: 'left',
            color: colorPrincipal
          }}>
            {formularioInfo.titulo && (
              <p><strong>Título:</strong> {formularioInfo.titulo}</p>
            )}
            {formularioInfo.fecha_fin && (
              <p><strong>Fecha de expiración:</strong> {formatearFecha(formularioInfo.fecha_fin)}</p>
            )}
            {formularioInfo.fecha_inicio && (
              <p><strong>Fecha de inicio:</strong> {formatearFecha(formularioInfo.fecha_inicio)}</p>
            )}
          </div>
        )}
        
        <Button 
          onClick={irAMisFormularios}
          style={{ 
            backgroundColor: colorPrincipal, 
            borderColor: colorPrincipal 
          }}
          size="lg"
        >
          Volver a Mis Formularios
        </Button>
      </Card>
    </div>
  );
};

export default FormularioBloqueado;